/**
 * Created by Nikita Besshaposhnikov on 16.11.15.
 */

/**
 * Animation type for physical robot.
 * @enum {String}
 * @readonly
 */
var PhysicalRobotAnimation = {
	Push: "push",
	ChangeState: "state"
};

/**
 * @class 2D sprite of {pm.data.PhysicalRobot}.
 * @implements pm.OrthoRobotSprite
 */
var PhysicalRobotSprite = pm.OrthoRobotSprite.extend(/** @lends PhysicalRobotSprite# */{

	_stateIndicator: null,

	ctor: function ()
	{
		cc.animationCache.addAnimations("Robot/physical_robot-animations.plist");

		pm.spriteUtils.registerTempSpriteFrames("Robot/physical_robot.plist");

		this._super(cc.spriteFrameCache.getSpriteFrame(this._getFrameName(0)));

		this._stateIndicator = new cc.ParticleSystem("Particles/light.plist");
		this._stateIndicator.setPositionType(cc.ParticleSystem.TYPE_GROUPED);
		this._stateIndicator.setScale(0.6);

		this.getSprite().addChild(this._stateIndicator, 1);
	},

	playAnimation: function(callback, target, type, args)
	{
		switch(type)
		{
			case PhysicalRobotAnimation.Push: this._push(args[0], args[1], args[2], callback, target); break;
			case PhysicalRobotAnimation.ChangeState: this._changeState(args); break;
			default: pm.OrthoRobotSprite.prototype.playAnimation.call(this, callback, target, type, args); break;
		}
	},

	_changeState: function(state)
	{
		switch (state)
		{
			case pm.PhysicalConnector.STATE.CONNECTED:
				this._stateIndicator.setPosition(this._getStateIndicatorPosition(state));
				this._stateIndicator.setStartColor(cc.color.GREEN);
				break;
			case pm.PhysicalConnector.STATE.DISCONNECTED:
				this._stateIndicator.setPosition(this._getStateIndicatorPosition(state));
				this._stateIndicator.setStartColor(cc.color.RED);
				break;
		}
	},

	_push: function(pos, direction, reverse, endCallback, target)
	{
		var targetBack = this.getRealPosition(pos);
		var targetPos = cc.p(pos.x, pos.y);

		if(!reverse)
		{
			switch (direction)
			{
				case MapDirection4.Up:
					targetPos.y *= 0.5;
					break;
				case MapDirection4.Left:
					targetPos.x *= 0.5;
					break;
				case MapDirection4.Down:
					targetPos.y *= 1.25;
					break;
				case MapDirection4.Right:
					targetPos.x *= 1.25;
					break;
			}

		}
		else
		{
			switch (direction)
			{
				case MapDirection4.Up:
					targetPos.y = (targetPos.y - 1) * 0.5;
					break;
				case MapDirection4.Left:
					targetPos.x = (targetPos.x - 1) * 0.5;
					break;
				case MapDirection4.Down:
					targetPos.y = (targetPos.y + 1) * 1.25;
					break;
				case MapDirection4.Right:
					targetPos.x = (targetPos.x + 1) * 1.25;
					break;
			}
		}

		targetPos = this.getRealPosition(targetPos);

		var callback = cc.callFunc(endCallback, target);

		if(!reverse)
		{
			var moveRobot = cc.moveTo(pm.settings.getAnimationSpeed() * 1.5, targetPos);
			var moveRobotBack = cc.moveTo(pm.settings.getAnimationSpeed() * 0.5, targetBack);

			this.sprite.runAction(cc.sequence(moveRobot, moveRobotBack, callback));
		}
		else
		{
			var moveRobot = cc.moveTo(pm.settings.getAnimationSpeed() * 0.5, targetPos);
			var moveRobotBack = cc.moveTo(pm.settings.getAnimationSpeed() * 1.5, targetBack);

			this.sprite.runAction(cc.sequence(moveRobot, moveRobotBack, callback));
		}
	},

	_getTurnAngle: function(direction)
	{
		return 180 - direction * 90;
	},

	_getFrameName: function (direction)
	{
		var connectionType = pm.settings.getPhysicalConnectorType();

		if(connectionType === pm.PhysicalConnectorType.Lego)
		{
			return "physical_robot_lego.png";
		}
		else
		{
			return "physical_robot_BLE.png";
		}
	},

	_getDestroyAnimationName: function (direction)
	{
		switch(pm.settings.getPhysicalConnectorType())
		{
			case pm.PhysicalConnectorType.Lego:
				return "physical_robot_lego_d";
			case pm.PhysicalConnectorType.Sound:
			case pm.PhysicalConnectorType.BLE:
			case pm.PhysicalConnectorType.None:
				return "physical_robot_BLE_d";

		}
	},

	_getIndicateAnimationName: function (direction)
	{
		switch(pm.settings.getPhysicalConnectorType())
		{
			case pm.PhysicalConnectorType.Lego:
				return "physical_robot_lego_i";
			case pm.PhysicalConnectorType.Sound:
			case pm.PhysicalConnectorType.BLE:
			case pm.PhysicalConnectorType.None:
				return "physical_robot_BLE_i";

		}
	},

	_getStateIndicatorPosition: function (state)
	{
		var connectionType = pm.settings.getPhysicalConnectorType();

		if(connectionType !== pm.PhysicalConnectorType.Lego)
		{
			if (state === pm.PhysicalConnector.STATE.CONNECTED)
				return cc.p(57, 50);
			else if (state === pm.PhysicalConnector.STATE.DISCONNECTED)
				return cc.p(23, 50);
		}
		else
		{
			return cc.p(33, 28);
		}
	}
});
